import styled from '@emotion/styled';

export const FiltersAndStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(5)};
  align-items: flex-start;
`;

export const DownloadButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(6)};
  margin-top: ${({ theme }) => theme.spacing(6)};
  border-top: ${({ theme }) => theme.borderLight};

  ${({ theme }) => theme.breakpoints.up('md')} {
    align-items: flex-start;
  }
`;
